import { TResultType } from 'legacy/lut/classes/models/partner360/ELT/financialData/kpi/IKpi'
import { KpiTableContent } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/kpiTable/components/kpiTableContent/KpiTableContent'
import React from 'react'

import styles from './KpiResultsCell.module.scss'

interface IKpiResultsCellProps {
  value: TResultType[] | null
  align?: 'start' | 'center'
}

export const KpiResultsCell = ({ value, align = 'start' }: IKpiResultsCellProps) => {
  if (!value) {
    return <div className={styles.kpiCell}>-</div>
  }
  return (
    <div className={styles.kpiCell}>
      {value.map((el, index) => (
        <KpiTableContent key={index} result={el} align={align} />
      ))}
    </div>
  )
}
